import { atom } from "recoil";

let today = new Date();

export const formSummaryDateRangeRecoilAtom = atom({
    key: "formSummaryDateRangeRecoilAtom",
    default: [
        {
            startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30),
            endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59),
            key: 'selection',
        },
    ],
});

export const showFormSummaryDateResetButtonAtom = atom({
    key: "showFormSummaryDateResetButtonAtom",
    default: false,
});

export const isDefaultDateRangeAtom = atom({
    key: "isDefaultDateRangeAtom",
    default: false,
});

export const formSummaryDataAtom = atom({
    key: "formSummaryDataAtom",
    default: {},
});

export const isFormSummaryLoadingAtom = atom({
    key: "isFormSummaryLoadingAtom",
    default: false,
});

export const filterByCreatedTimestampAtom = atom({
    key: "filterByCreatedTimestampAtom",
    default: false,
});